
export interface ScanditRefs {
  contextRef: React.MutableRefObject<any>;
  cameraRef: React.MutableRefObject<any>;
  barcodeCaptureRef: React.MutableRefObject<any>;
  viewRef: React.MutableRefObject<any>;
  listenerRef: React.MutableRefObject<any>;
  ScanditCoreRef: React.MutableRefObject<any>;
  ScanditBarcodeRef: React.MutableRefObject<any>;
  isCleaningUpRef: React.MutableRefObject<boolean>;
}

export const cleanupScanditSession = async (
  refs: ScanditRefs,
  videoRef: React.RefObject<HTMLDivElement>
) => {
  if (refs.isCleaningUpRef.current) {
    console.log('⚠️ Cleanup already in progress, skipping...');
    return;
  }
  
  refs.isCleaningUpRef.current = true;
  console.log('🧹 Cleaning up Scandit scanner...');
  
  try {
    // Disable barcode capture and remove listener
    if (refs.barcodeCaptureRef.current) {
      try {
        refs.barcodeCaptureRef.current.setEnabled(false);
        if (refs.listenerRef.current) {
          refs.barcodeCaptureRef.current.removeListener(refs.listenerRef.current);
          refs.listenerRef.current = null;
        }
      } catch (e) {
        console.warn('Error disabling barcode capture:', e);
      }
      refs.barcodeCaptureRef.current = null;
    }
    
    // Turn off camera first
    if (refs.cameraRef.current) {
      try {
        await refs.cameraRef.current.switchToDesiredState('off');
        console.log('✅ Camera turned off');
      } catch (e) {
        console.warn('Error turning off camera:', e);
      }
    }
    
    // Clean up view carefully
    if (refs.viewRef.current) {
      try {
        // First disconnect from element
        if (videoRef.current) {
          refs.viewRef.current.connectToElement(null);
          console.log('✅ View disconnected from element');
        }
        
        // Small delay to ensure disconnection is complete
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Then dispose if method exists
        if (typeof refs.viewRef.current.dispose === 'function') {
          await refs.viewRef.current.dispose();
          console.log('✅ View disposed');
        }
      } catch (viewError) {
        console.warn('⚠️ View cleanup warning:', viewError);
      }
      refs.viewRef.current = null;
    }
    
    // Clear video container
    if (videoRef.current) {
      videoRef.current.innerHTML = '';
    }
    
    // Dispose context last
    if (refs.contextRef.current && typeof refs.contextRef.current.dispose === 'function') {
      try {
        await refs.contextRef.current.dispose();
        console.log('✅ Context disposed');
      } catch (e) {
        console.warn('Error disposing context:', e);
      }
      refs.contextRef.current = null;
    }
    
    console.log('✅ Cleanup completed successfully');
  } catch (e) {
    console.error('❌ Error during cleanup:', e);
  } finally {
    refs.isCleaningUpRef.current = false;
  }
};
